/* ==========================================================================
   Casemira, choix de la taille                    C1, vagues 1, 3, 5 et 7
   --------------------------------------------------------------------------
   Contrat : SPEC.md point 5, VAGUE 3 points A1 et A2, VAGUE 5 point 3,
             VAGUE 7 points 1, 2 et 3.

   Le selecteur de taille (snippets/dropdown-size-picker.liquid +
   assets/casemira-dropdown-size-picker.js) pousse la variante choisie vers les
   radios de <variant-selects>, donc vers le JS de variante du theme, qui met a
   jour le prix du haut, le bouton d'achat, la disponibilite et l'URL ?variant=.

   ── LE BUG DE LA VAGUE 1, ET SA CAUSE (mesure sur la preview le 21/08) ──
   Au clic sur un autre format, le prix suivait mais la SELECTION revenait sur
   la premiere variante. product-info.js (handleUpdateProductInfo) calcule la
   nouvelle variante dans une variable locale, s'en sert partout, et dispatche
   `variant:changed` avec `this.currentVariant`, qu'il ne met jamais a jour dans
   cette branche : `event.detail.variant` porte donc la variante INITIALE de la
   page, a chaque changement. On ne lit donc JAMAIS `event.detail`. La source de
   verite est `input[name="id"]` du formulaire, que product-info.js ecrit
   (updateVariantInputs) juste avant de dispatcher, et qui est de toute facon ce
   qui part au panier.

   ── ★ C1 VAGUE 7, POINT 1 : LE CHANGEMENT DE FORMAT DEVIENT INSTANTANE ──
   Mesure du 22/08 sur la preview, avant : 261 a 272 ms sur iPhone 430 et 239 ms
   en desktop entre le doigt et le nouveau prix. Ce n'est pas un defaut de code,
   c'est l'aller-retour reseau de la Section Rendering API : le theme demande au
   serveur le HTML de la section entiere, puis remplace des noeuds. DESIGN.md,
   regle Le Geste est Instantane : « toute action recoit un retour visible en
   moins de 120 ms, AVANT meme que le serveur ait repondu ».

   Ce fichier repeint donc tout ce qui est visible, en JavaScript, dans le meme
   tour d'evenement que le tap, a partir des donnees de variantes deja dans la
   page (voir sections/main-product.liquid, `<script class="cm-pdp-variants">`,
   avec repli sur les `data-*` des lignes du selecteur quand ce bloc n'est pas
   encore servi). Le re-rendu du theme suit et ne fait plus que confirmer.

   Ce que la repeinture couvre : le prix du haut, « Format : … », le bouton
   d'ajout (libelle et prix), la ligne Klarna, la barre collante mobile,
   `input[name="id"]`, l'URL `?variant=`, la ligne de rarete, l'etat selectionne
   des pastilles et l'etat ferme du tiroir.

   Ce qu'elle NE fait pas : elle n'annule pas le re-rendu du theme. Certaines
   choses ne peuvent venir que du serveur (regles de quantite, disponibilite en
   magasin, prix a l'unite, media associe a une variante). Une seule zone du
   re-rendu est interceptee, et pour une raison mesuree : la galerie
   (`updateMedia`, voir mediaGuard plus bas).

   Aucune bibliotheque. Charge en defer.
   ========================================================================== */
(function () {
  'use strict';

  /* ★ C1 VAGUE 9, point 2 : ce fichier est desormais charge par DEUX endroits,
     snippets/dropdown-size-picker.liquid (les fiches a tiroir ou a pastilles) et
     snippets/casemira-pdp-reskin.liquid (toutes les fiches, y compris celles qui
     affichent le selecteur natif `dimension-picker`, c'est-a-dire les 125 fiches
     a deux options « Taille + Forme »). Le navigateur execute un `<script src>`
     autant de fois qu'il est ecrit : sans cette garde, tous les ecouteurs
     seraient poses deux fois. */
  if (window.__cmSizePicker) return;
  window.__cmSizePicker = 1;

  /* i18n R2b : table lue UNE fois, repli code (CONVENTION.md § 3). Les deux
     libelles standards du bouton d'achat (« Ajouter au panier », « Épuisé »)
     restent lus d'abord dans `FoxTheme.variantStrings`, qui est deja traduit
     par le theme : la table ne sert qu'a leur REPLI, et aux phrases qui
     n'appartiennent qu'a ce selecteur. */
  var S = (window.FoxTheme && window.FoxTheme.casemira && window.FoxTheme.casemira.fiche) || {};

  function avec(modele, jeton, valeur) {
    return String(modele).split(jeton).join(valeur);
  }

  var SECTION = '.section-main-product';
  var STORE_PREFIX = 'cm.pdp.format.';

  /* Les deux selecteurs de dimension de la boutique. Le premier est le notre
     (snippets/dropdown-size-picker.liquid, pastilles a plat ou tiroir) ; le
     second est celui du thème (snippets/dimension-picker.liquid), rendu sur les
     gabarits `outdoor-2`, `magic-home-2` et `handmade-carpet-decor`, qui sont
     precisement ceux des fiches a deux options. Ils partagent l'essentiel :
     un bouton par format, `data-variant-id` et `data-size-value`. */
  var ROW_SEL = '.dw-picker__row, .dimension-btn';

  /* ★ C1 VAGUE 7, point 2 (precision du proprietaire du 22/08 a 12h47) ·
     LA FOURCHETTE DE SUGGESTION
     --------------------------------------------------------------------------
     Un format epuise ne propose un remplacant que si celui-ci reste dans le
     meme ordre de grandeur : entre 0,6 et 1,6 fois sa surface. Au-dela, la
     suggestion cesse d'etre un service. Proposer un 160 × 230 (3,7 m²) a qui
     demandait un 250 × 350 (8,75 m²) revient a proposer un autre meuble : la
     personne a mesure sa piece, et 0,42 fois la surface ne la couvre pas.
     Les deux bornes sont ici, et nulle part ailleurs, pour se regler d'une
     ligne. */
  var NEAR_MIN_RATIO = 0.6;
  var NEAR_MAX_RATIO = 1.6;

  /* L'URL telle qu'elle etait a l'ARRIVEE, relevee avant que quoi que ce soit
     ne la reecrive. `paint()` pose `?variant=` des le premier appel : lire
     `location.search` plus tard reviendrait a croire que toute page porte un
     lien profond, et la memoire du format ne se declencherait jamais. Defaut
     trouve a la mesure du 22/08, sur la deuxieme couleur d'un meme modele. */
  var INITIAL_SEARCH = location.search;

  /* La variante avec laquelle le serveur a rendu la page. Elle sert a ne PAS
     ecrire `?variant=` dans l'URL tant que rien n'a change : le theme ne le fait
     pas non plus a l'arrivee, et une fiche partagee doit garder une adresse
     propre. */
  var INITIAL_ID = null;

  function scope() {
    return document.querySelector(SECTION);
  }

  function reducedMotion() {
    return !!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);
  }

  /* Meme normalisation que casemira-pdp-reskin.js (dwLabels) : « 120 x 170 cm »
     devient « 120 × 170 cm ». On l'ecrit ici pour ne pas laisser paraitre le
     libelle brut le temps d'un tour d'observateur. */
  function niceSize(raw) {
    return (raw || '')
      .replace(/(\d)\s*[xX]\s*(\d)/g, '$1 × $2')
      .replace(/\s*cm\b/i, ' cm')
      .trim();
  }

  function currentVariantId() {
    var input = document.querySelector(
      SECTION + ' form[data-type="add-to-cart-form"] input[name="id"]'
    );
    if (input && input.value) return String(input.value);
    var json = document.querySelector(SECTION + ' variant-selects [data-selected-variant]');
    if (!json) return '';
    try {
      var parsed = JSON.parse(json.textContent);
      return parsed && parsed.id ? String(parsed.id) : '';
    } catch (e) {
      return '';
    }
  }

  /* ------------------------------------------------------------------------
     1 · Le catalogue des variantes
     ------------------------------------------------------------------------
     Deux sources, dans cet ordre :

       a. le bloc `<script type="application/json" class="cm-pdp-variants">`
          rendu par sections/main-product.liquid. Il porte les DEUX formats
          monetaires du theme (`money` pour le bloc de prix, `money_without_
          trailing_zeros` pour le selecteur), la disponibilite, le prix barre et
          le media de la variante ;

       b. a defaut, les `data-*` que le selecteur porte deja sur chaque ligne.
          Elles suffisent a tout sauf au format `money` du bloc de prix, qui est
          alors DEDUIT (voir learnMoney) plutot que devine.

     Le repli n'est pas une precaution de style : tant que le Liquid n'est pas
     pousse, la preview ne sert que le second. C'est aussi ce qui rend ce
     fichier sans danger sur une page en cache.
     ---------------------------------------------------------------------- */
  var CAT = null;

  function readJsonBlock() {
    var el = document.querySelector(SECTION + ' script.cm-pdp-variants')
          || document.querySelector('script.cm-pdp-variants');
    if (!el) return null;
    try {
      var d = JSON.parse(el.textContent);
      return d && d.variants && d.variants.length ? d : null;
    } catch (e) {
      return null;
    }
  }

  /* La forme d'un format, lue dans son libelle. Un rond ne remplace pas un
     rectangle et un rectangle ne remplace pas un rond : ce n'est pas une
     question de surface, c'est une question de piece. Le tapis rond se pose
     sous une table ronde ou dans une entree ; le rectangle habille un salon.
     (La forme est par ailleurs une option a part sur ces fiches, `forme-selector` :
     changer de forme est un autre geste, qui a son propre selecteur.) */
  function shapeOf(raw) {
    var s = String(raw || '');
    if (/ovale/i.test(s)) return 'ovale';
    if (/ø|diam|rond/i.test(s)) return 'rond';
    return 'rect';
  }

  /* Surface d'un format, pour classer les formats entre eux.
     « 120 x 170 cm » -> 20 400 cm². « Ø 200 cm » -> un disque, pas un carre :
     π × (D/2)², sinon un rond de 200 passerait pour un rectangle de 200 × 200 et
     serait juge plus grand qu'un 190 × 190 qui, lui, l'est vraiment. */
  function areaOf(raw) {
    var s = String(raw || '');
    var nums = s.replace(/\s/g, '').match(/\d+([.,]\d+)?/g);
    if (!nums || !nums.length) return 0;
    var v = nums.map(function (n) { return parseFloat(n.replace(',', '.')); });
    if (shapeOf(s) !== 'rect' || v.length === 1) {
      var r = v[0] / 2;
      return Math.PI * r * r;
    }
    return v[0] * v[1];
  }

  /* Le format `money` du bloc de prix, deduit du format `money_without_
     trailing_zeros` du selecteur. On ne devine rien : on compare, pour la
     variante COURANTE, ce que le selecteur ecrit (« 99 € ») et ce que le bloc
     de prix affiche (« 99,00 € »). Si l'un est l'autre avec des decimales
     inserees, la meme insertion vaut pour toutes les autres. Sinon, on renvoie
     le texte du selecteur tel quel : un format legerement different vaut mieux
     qu'un prix faux. */
  function learnMoney(rows, curId) {
    var block = document.querySelector(SECTION + ' .product__block--price .f-price__sale .f-price-item--sale')
             || document.querySelector(SECTION + ' .product__block--price .f-price-item--regular');
    var cur = null;
    for (var i = 0; i < rows.length; i++) {
      if (String(rows[i].getAttribute('data-variant-id')) === String(curId)) cur = rows[i];
    }
    if (!block || !cur) return null;
    var short = (cur.getAttribute('data-price') || '').trim();
    var full = (block.textContent || '').trim();
    if (!short || !full || short === full) return null;
    /* On isole les chiffres de chaque cote : meme entier, deux decimales de
       plus d'un cote, et le meme habillage. */
    var mS = short.match(/^(.*?)(\d[\d   .]*)(.*)$/);
    var mF = full.match(/^(.*?)(\d[\d   .]*)([.,]\d{2})(.*)$/);
    if (!mS || !mF) return null;
    if (mS[1] !== mF[1] || mS[3] !== mF[4]) return null;
    if (mS[2] !== mF[2]) return null;
    var dec = mF[3];
    return function (shortText) {
      var m = String(shortText || '').match(/^(.*?)(\d[\d   .]*)(.*)$/);
      if (!m) return shortText;
      if (/[.,]\d{2}/.test(m[3])) return shortText;
      return m[1] + m[2] + dec + m[3];
    };
  }

  /* ★ C1 VAGUE 9, point 2 · LE CATALOGUE CONNAIT MAINTENANT LES OPTIONS
     ------------------------------------------------------------------------
     Jusqu'ici une variante etait identifiee par son libelle de format, et la
     ligne cliquee donnait directement son `data-variant-id`. Cela suffit tant
     qu'il n'y a qu'une option. Des qu'il y en a deux (« Taille » et « Forme »,
     125 fiches de la boutique), le libelle de la variante devient
     « 160 x 230 cm / Rectangulaire » et la ligne ne suffit plus : c'est
     l'ENSEMBLE des options selectionnees qui designe la variante.

     Le bloc JSON de sections/main-product.liquid publie deja, depuis la vague 7,
     `optionNames` et le tableau `options` de chaque variante. On s'en sert : le
     catalogue devient la liste complete des variantes, et les lignes du
     selecteur y sont RATTACHEES, au lieu d'en etre la source. Le repli sur les
     `data-*` des lignes reste entier pour les pages servies sans ce bloc. */
  function optionNamesOf(json) {
    if (json && json.optionNames && json.optionNames.length) return json.optionNames.slice();
    var host = scope();
    var names = [];
    if (host) {
      host.querySelectorAll('variant-selects [data-option-name]').forEach(function (el) {
        var n = el.getAttribute('data-option-name');
        if (n && names.indexOf(n) === -1) names.push(n);
      });
    }
    if (names.length) return names;
    /* CASEMIRA i18n R2c. Le repli etait `['Taille']`, ecrit en francais : en
       /en `sizeIndexOf` ne reconnaissait plus rien et retombait sur 0 par
       chance. `FoxTheme.casemira.options.noms` porte les noms d'option du
       produit courant, dans la langue du visiteur, poses cote serveur par
       snippets/casemira-options-map.liquid. Repli code en dur derriere, jamais
       `undefined`. */
    var O = (window.FoxTheme && FoxTheme.casemira && FoxTheme.casemira.options) || {};
    if (O.noms && O.noms.length) return O.noms.slice();
    var hote = document.querySelector('[data-cm-opt-noms]');
    if (hote) {
      try {
        var liste = JSON.parse(hote.getAttribute('data-cm-opt-noms') || '[]');
        if (liste && liste.length) return liste;
      } catch (e) {}
    }
    return ['Taille'];
  }

  /* L'index de l'option qui porte la dimension. C'est elle que le selecteur de
     taille fait varier ; les autres (la forme) sont choisies ailleurs. */
  /* L'index de l'option « Forme », s'il existe. Le selecteur du thème
     (snippets/dimension-picker.liquid) ecrit sa valeur sur chaque bouton, dans
     `data-form-value`, et assets/dimension-picker.js s'en sert pour recocher la
     radio de forme au clic. Elle est calculee cote SERVEUR : apres un
     changement de forme sans rechargement, elle est perimee, et le clic
     suivant sur une dimension ramenait a l'ancienne forme (mesure du 22/08 sur
     la fiche 2 x 2 rejouee). On la tient a jour. */
  /* CASEMIRA i18n R2c. Les deux resolutions ci-dessous testaient le NOM de
     l'option avec une expression fr + en. Le serveur les a deja resolues, dans
     les quatre langues, et publie les INDEX 1-BASES dans
     `FoxTheme.casemira.options`. On les prend quand ils sont la ; sinon on
     garde l'ancienne expression, elargie au de et au nl, comme repli : ce
     module tourne aussi sur des pages servies sans le pont.
     03/10/2026 : le repli connait aussi l'italien et l'espagnol (« Misura »,
     « Tamaño », « Forma », « Larghezza », « Ancho »). La liste de reference
     reste celle de snippets/casemira-options-map.liquid ; ce repli n'en est
     que l'echo, a tenir aligne. */
  function roleIndex(role) {
    var O = (window.FoxTheme && FoxTheme.casemira && FoxTheme.casemira.options) || {};
    var i = O[role];
    if (typeof i === 'number' && i > 0) return i - 1;
    /* Seconde source : les `data-cm-opt-*` poses sur `.product` par
       sections/main-product.liquid, avec la meme resolution et le meme
       snippet. Couvre les rendus ou le pont d'entete n'a pas vu le produit. */
    var hote = document.querySelector('[data-cm-opt-' + role + ']');
    if (hote) {
      var n = parseInt(hote.getAttribute('data-cm-opt-' + role), 10);
      if (n > 0) return n - 1;
    }
    return -1;
  }

  function formIndexOf(names) {
    var i = roleIndex('forme');
    if (i >= 0 && i < names.length) return i;
    for (i = 0; i < names.length; i++) {
      /* 04/10/2026 : « Tvar » (cs, sk) ; « Forma » (pt) et « Form » (da) passaient deja.
         15h : « Oblik » (hr), « Formă » (ro). 22h : « Form » (sv, deja la), « Muoto » (fi),
         « Σχήμα » (el). 06/10 : « Форма » (bg), « Oblika » (sl), « Forma » (lv, deja la), « Kuju » (et), « Forma » (lt, deja la). */
      if (/forme|shape|vorm|^form$|^forma$|^tvar$|^oblik$|^formă$|^muoto$|^σχήμα$|^форма$|^oblika$|^kuju$/i.test(names[i])) return i;
    }
    return -1;
  }

  function sizeIndexOf(names) {
    var i = roleIndex('taille');
    if (i >= 0 && i < names.length) return i;
    for (i = 0; i < names.length; i++) {
      /* 04/10/2026, repli seulement (le serveur donne l'index par data-cm-opt-taille) :
         pt Tamanho, Largura, Dimensões ; cs Rozměr, Velikost, Šířka ; sk Rozmer, Šírka ;
         da Størrelse, Bredde ; hu Méret, Szélesség (04/10, 11h) ; hr Veličina, Širina ;
         ro Dimensiune (deja par « dimension »), Mărime, Lățime (04/10, 15h) ; sv Storlek, Bredd,
         Mått ; fi Koko, Leveys, Mitat ; el Μέγεθος, Πλάτος, Διαστάσεις (04/10, 22h) ; bg Размер,
         Ширина, Размери ; sl Velikost, Širina, Mere ; lv Izmērs, Platums, Izmēri ; et Suurus, Laius, Mõõdud ; lt Dydis, Plotis, Išmatavimai (06/10). */
      if (/taille|size|dimension|dimensión|dimens(ã|a)o|dimens(õ|o)es|largeur|gr(ö|oe|o)sse|maat|abmessung|breite|misur|tama(ñ|n)o|medida|larghezza|ancho|tamanho|largura|rozm(ě|e)r|velikost|(š|s)(í|i)(ř|r)ka|st(ø|o)rrelse|bredde|m(é|e)ret|sz(é|e)less(é|e)g|veli(č|c)ina|(š|s)irina|m(ă|a)rime|l(ă|a)(ț|ţ|t)ime|storlek|bredd|m(å|a)tt|^koko$|leveys|^mitat$|μέγεθος|πλάτος|διαστάσ|размер|ширина|^mere$|izmēr|platums|suurus|laius|mõõdud|dydis|plotis|išmatavim/i.test(names[i])) return i;
    }
    return 0;
  }

  function optionsOf(jv, title) {
    if (jv && jv.options && jv.options.length) return jv.options.slice();
    return String(title || '').split(' / ');
  }

  function buildCatalogue() {
    var host = scope();
    if (!host) return null;
    var picker = host.querySelector('.dw-picker') || host.querySelector('.dimension-picker-container');
    var rows = picker ? Array.prototype.slice.call(picker.querySelectorAll(ROW_SEL)) : [];
    var json = readJsonBlock();
    if (!rows.length && !json) return null;

    var curId = currentVariantId();
    var toMoney = learnMoney(rows, curId);
    var names = optionNamesOf(json);
    var sIdx = sizeIndexOf(names);
    var rowById = {};
    var rowBySize = {};
    rows.forEach(function (row) {
      var id = row.getAttribute('data-variant-id');
      if (id) rowById[String(id)] = row;
      var sv = (row.getAttribute('data-size-value') || '').trim();
      if (sv && !rowBySize[sv]) rowBySize[sv] = row;
    });

    var list = [];
    var byId = {};

    function push(id, jv, row, priceText, compareText, available, title) {
      var opts = optionsOf(jv, title);
      var sizeRaw = opts[sIdx] != null ? opts[sIdx] : title;
      var e = {
        id: String(id),
        row: row || null,
        options: opts,
        sizeValue: String(sizeRaw || '').trim(),
        sizeRaw: sizeRaw,
        size: niceSize(sizeRaw),
        available: !!available,
        priceText: priceText || '',
        priceMoney: (jv && jv.priceMoney) || (toMoney ? toMoney(priceText) : priceText) || '',
        compareText: compareText || '',
        compareMoney: (jv && jv.compareMoney) || (toMoney ? toMoney(compareText) : compareText) || '',
        priceCents: jv ? jv.price : null,
        compareCents: jv ? jv.comparePrice : 0,
        mediaId: jv ? String(jv.mediaId || '') : '',
        /* Le SEUIL de rarete reelle (1, 2 ou 3), tel que
           sections/main-product.liquid le publie, ou null. On ne le deduit pas
           du DOM : une ligne du selecteur peut etre reaffectee a une autre
           variante quand la forme change (voir paintPickerState), la variante,
           elle, ne change pas de chiffre. Le repli sur les `data-*` des lignes
           ne porte pas cette donnee : sans bloc JSON, la valeur reste null et
           la rarete virtuelle garde la main, comme avant. */
        scarcity: (jv && typeof jv.scarcity === 'number') ? jv.scarcity : null,
        shape: shapeOf(sizeRaw),
        area: areaOf(sizeRaw)
      };
      byId[e.id] = e;
      list.push(e);
      /* La VALEUR d'option que porte cette ligne, retenue une fois pour toutes.
         `data-size-value` ne peut pas servir : sur une fiche a deux options il
         contient le libelle entier de la variante (« 160 x 230 cm /
         Rectangulaire »), et `data-variant-id` est reecrit a chaque changement
         de forme. */
      if (row && !row.__cmSize) row.__cmSize = e.sizeValue;
    }

    if (json) {
      /* Source complete : TOUTES les variantes, y compris celles de l'autre
         forme, dont aucune ligne n'existe dans la page. */
      json.variants.forEach(function (jv) {
        var opts = optionsOf(jv, jv.title);
        var row = rowById[String(jv.id)] || rowBySize[String(opts[sIdx] || '').trim()] || null;
        push(
          jv.id, jv, row,
          (row && row.getAttribute('data-price')) || jv.priceText,
          (row && row.getAttribute('data-compare-price')) || jv.comparePriceText,
          jv.available, jv.title
        );
      });
    } else {
      rows.forEach(function (row) {
        var id = row.getAttribute('data-variant-id');
        if (!id) return;
        var title = row.getAttribute('data-size-value') || '';
        push(
          id, null, row,
          row.getAttribute('data-price') || '',
          row.getAttribute('data-compare-price') || '',
          row.hasAttribute('data-available')
            ? row.getAttribute('data-available') === 'true'
            : !(row.disabled || row.classList.contains('is-unavailable')),
          title
        );
      });
    }

    /* Les fiches de couleur sont des PRODUITS distincts, relies par le
       metachamp `custom.couleurs_associees` (snippets/color-siblings.liquid).
       Le bloc JSON en donne les handles ; a defaut on les relit dans le DOM,
       ou les pastilles de couleur portent deja les URL. */
    var siblings = (json && json.siblings) ? json.siblings.slice() : [];
    if (!siblings.length) {
      var here = location.pathname.split('/').pop();
      siblings = [here];
      host.querySelectorAll('.color-siblings__item[href]').forEach(function (a) {
        var h = a.getAttribute('href').split('?')[0].split('/').pop();
        if (h && siblings.indexOf(h) === -1) siblings.push(h);
      });
    }

    return {
      list: list,
      byId: byId,
      picker: picker,
      rows: rows,
      optionNames: names,
      sizeIndex: sIdx,
      formIndex: formIndexOf(names),
      multi: names.length > 1,
      handle: (json && json.handle) || location.pathname.split('/').pop(),
      url: (json && json.url) || location.pathname,
      siblings: siblings,
      reassort: !!(json && json.reassort)
    };
  }

  function catalogue() {
    var host = scope();
    if (!host) return null;
    var n = host.querySelectorAll(ROW_SEL).length;
    if (!CAT || CAT.rows.length !== n || !CAT.picker || !CAT.picker.isConnected) {
      CAT = buildCatalogue();
    }
    return CAT;
  }

  /* ------------------------------------------------------------------------
     2 · Repeindre, tout de suite
     ---------------------------------------------------------------------- */
  function setText(el, txt) {
    if (el && (el.textContent || '').trim() !== txt) el.textContent = txt;
  }

  /* Le libelle nu du bouton d'ajout (« Ajouter au panier »), releve UNE fois.
     Deux sources, dans cet ordre :
       1. `FoxTheme.variantStrings.addToCart`, la chaine de traduction du theme.
          C'est la meme que product-info.js remet lui-meme sur le bouton
          (toggleAddButton) : la prendre garantit que les deux ecrivent le meme
          mot ;
       2. a defaut, le libelle deja dans le bouton, debarrasse du prix que
          casemira-pdp-reskin.js y accroche.
     La seconde source n'est lue QUE si le bouton est actif : sur une fiche dont
     la variante par defaut est epuisee, il affiche « Épuisé », et le relever la
     ferait ecrire « Épuisé · 149,00 € » au premier format disponible choisi. */
  var ADD_LABEL = null;
  function addLabel(txt, enabled) {
    if (ADD_LABEL !== null) return ADD_LABEL;
    try {
      var t = window.FoxTheme && window.FoxTheme.variantStrings && window.FoxTheme.variantStrings.addToCart;
      if (t) {
        ADD_LABEL = String(t).replace(/<[^>]*>/g, '').replace(/\s+/g, ' ').trim();
        if (ADD_LABEL) return ADD_LABEL;
      }
    } catch (e) {}
    if (!txt || !enabled) return S.ajouterAuPanier || 'Ajouter au panier';
    var clone = txt.cloneNode(true);
    clone.querySelectorAll('.cm-cart-sep, .cm-cart-price').forEach(function (e) { e.remove(); });
    ADD_LABEL = (clone.textContent || '').replace(/\s+/g, ' ').trim() || S.ajouterAuPanier || 'Ajouter au panier';
    return ADD_LABEL;
  }

  function soldOutLabel() {
    try {
      var s = window.FoxTheme && window.FoxTheme.variantStrings && window.FoxTheme.variantStrings.soldOut;
      if (s) return String(s).replace(/<[^>]*>/g, '').trim();
    } catch (e) {}
    return S.epuise || 'Épuisé';
  }

  function paintPrice(v) {
    var pc = document.querySelector(SECTION + ' .product__block--price [id^="price-"]');
    if (!pc) return;
    var box = pc.querySelector('.f-price');
    var onSale = !!(v.compareMoney && v.compareCents && v.compareCents > (v.priceCents || 0))
              || !!(v.compareText && v.compareText !== v.priceText && box && box.classList.contains('f-price--on-sale') && v.compareCents === null);
    if (v.compareCents !== null) onSale = v.compareCents > (v.priceCents || 0);
    else onSale = !!(v.compareText && v.compareText.replace(/\s/g, '') !== '' && v.compareText !== v.priceText);

    if (box) box.classList.toggle('f-price--on-sale', onSale);
    pc.querySelectorAll('.f-price__regular .f-price-item--regular').forEach(function (e) {
      setText(e, v.priceMoney);
    });
    setText(pc.querySelector('.f-price__sale .f-price-item--sale'), v.priceMoney);
    var s = pc.querySelector('.f-price__sale s');
    if (s) setText(s, onSale ? v.compareMoney : '');

    /* « Format : 120 × 170 cm », a cote du prix. product-info.js reecrit tout
       le contenu du bloc au retour du reseau : casemira-pdp-reskin.js le repose
       dans le meme tour d'evenement, et ce fichier le repose ici, avant meme la
       requete. Les deux ecrivent la meme chose ; le premier arrive gagne. */
    var size = v.size;
    if (size && !/cm\s*$/i.test(size)) size += ' cm';
    if (size) {
      var fmt = pc.querySelector('.cm-price-format');
      if (!fmt) {
        fmt = document.createElement('span');
        fmt.className = 'cm-price-format';
        pc.appendChild(fmt);
      }
      var want = avec(S.formatLabel || 'Format : [t]', '[t]', '<strong>' + size + '</strong>');
      if (fmt.innerHTML !== want) fmt.innerHTML = want;
    }
  }

  function paintButton(v) {
    var form = document.querySelector(SECTION + ' form[data-type="add-to-cart-form"]');
    if (!form) return;
    var btn = form.querySelector('[name="add"]');
    if (!btn) return;
    var txt = btn.querySelector('.btn__text');
    if (!txt) return;
    addLabel(txt, !btn.hasAttribute('disabled'));

    if (!v.available) {
      btn.setAttribute('disabled', 'disabled');
      setText(txt, soldOutLabel());
      return;
    }
    btn.removeAttribute('disabled');
    /* Le libelle est reecrit EN ENTIER des qu'il n'est pas exactement celui
       qu'on veut, y compris pour un blanc de difference. Le HTML servi par le
       theme ecrit « Ajouter au panier\n » avec un retour a la ligne avant le
       point median, et casemira-pdp-reskin.js reecrit le meme libelle sans ce
       retour : sans normalisation, le bouton se decalait de la largeur d'une
       espace au moment ou le serveur confirmait, un tiers de seconde apres le
       tap. Une comparaison de chaine coute moins qu'un pixel qui bouge. */
    var want = addLabel(txt, true)
      + '<span class="cm-cart-sep">·</span>'
      + '<span class="cm-cart-price">' + String(v.priceMoney).replace(/[<>&]/g, '') + '</span>';
    if (txt.innerHTML !== want) txt.innerHTML = want;
  }

  /* La ligne Klarna. Elle est rendue par un bloc « contenu Liquid » du modele
     (templates/product.*.json), pas par un fichier du thème : on ne la deplace
     pas et on ne la restyle pas (le proprietaire a annule ce point le 22/08 a
     12h25). On se contente de la mettre a jour TOUT DE SUITE, la ou elle est.
     Son propre script attend un `change` puis 60 ms ; a ce moment-la le prix
     du haut a deja bouge, et la mensualite reste en retard d'un format.

     Les prix en centimes de TOUTES les variantes sont deja sur l'element
     (`data-prices`), avec les bornes d'eligibilite : rien a inventer, et le
     calcul est repris a l'identique (arrondi au centime superieur). */
  /* RETROFIT i18n (R11) · LE FORMAT MONETAIRE SUIT LA LANGUE DE LA PAGE.
     `FoxTheme.casemira.prix` porte le gabarit de la langue courante (« €{{amount}} »
     en anglais, « {{amount_with_comma_separator}} € » en francais) et sa variante
     sans decimales ; `FoxTheme.Currency.formatMoney` sait les appliquer.

     LE FRANCAIS PASSE PAR LA MEME PORTE, et c'est delibere : l'ancien code posait
     une espace de milliers (« 1 234,56 € ») la ou le serveur ecrit un point
     (« 5.329,00 € » sur la collection). Deux verites dans la meme page pour un
     meme montant, c'est le defaut qu'on ferme ici. Le repli reste l'ancien code,
     mot pour mot, si le pont ou `FoxTheme.Currency` manquent : aucun ecran vide. */
  function cmPrixLocalise(cents) {
    var P = (window.FoxTheme && FoxTheme.casemira && FoxTheme.casemira.prix) || {};
    var fmt = (cents % 100 === 0) ? P.format_sans_zeros : P.format;
    if (!fmt || !window.FoxTheme || !FoxTheme.Currency || !FoxTheme.Currency.formatMoney) return null;
    try { return FoxTheme.Currency.formatMoney(cents, fmt); } catch (e) { return null; }
  }

  function paintKlarna(v) {
    var line = document.getElementById('casemira-klarna-line');
    if (!line) return;
    var prices;
    try { prices = JSON.parse(line.getAttribute('data-prices') || '{}'); } catch (e) { prices = {}; }
    var cents = prices[v.id];
    if (cents == null) cents = v.priceCents;
    if (cents == null) return;
    /* FRANCE (17/09) · quand Liquid a rendu la ligne DUO Klarna 3x + PayPal 4x
       (attribut `data-cm-pf`, acheteurs France seulement, voir
       `snippets/casemira-pdp-klarna.liquid`), la bascule porte sur DEUX lignes
       et sur DEUX montants. Partout ailleurs l'attribut n'existe pas et rien
       de ce chemin ne s'execute : le comportement d'avant est intact. */
    if (line.getAttribute('data-cm-pf') === '1') {
      paintKlarnaFr(line, cents);
      return;
    }
    var min = parseInt(line.getAttribute('data-klarna-min-cents'), 10);
    var max = parseInt(line.getAttribute('data-klarna-max-cents'), 10);
    if (!isNaN(min) && !isNaN(max) && (cents < min || cents > max)) {
      line.style.display = 'none';
      return;
    }
    line.style.display = '';
    var el = document.getElementById('casemira-klarna-installment');
    if (!el) return;
    /* RETROFIT i18n (R11) : la mensualite Klarna suit le format monetaire de la
       langue, francais compris : « ou 16,34 € × 3 » devient « or €16.34 × 3 ». */
    var mens = Math.ceil(cents / 3);
    var localise = cmPrixLocalise(mens);
    if (localise !== null) { setText(el, localise); return; }
    var c = mens / 100;
    var s = (c % 1 === 0) ? String(c) : c.toFixed(2).replace('.', ',');
    setText(el, s + ' €');
  }

  /* Un montant d'echeance, ecrit dans le format monetaire de la langue. C'est
     la fin de `paintKlarna` sortie telle quelle, pour ne pas l'ecrire trois
     fois : la mensualite Klarna, le quart PayPal de la ligne duo et celui de
     la ligne PayPal seul passent tous par ici. */
  function paintEcheance(el, cents) {
    if (!el) return;
    var localise = cmPrixLocalise(cents);
    if (localise !== null) { setText(el, localise); return; }
    var c = cents / 100;
    setText(el, ((c % 1 === 0) ? String(c) : c.toFixed(2).replace('.', ',')) + ' €');
  }

  /* FRANCE · les deux lignes sont RENDUES par Liquid, traduites ; ici on ne
     fait que choisir laquelle se montre et reecrire ses montants. Aucune
     phrase n'est ecrite dans ce fichier. Bornes lues sur le noeud, jamais
     recopiees : elles n'ont qu'une seule source, le snippet Liquid.
       35 EUR a 1 500 EUR      -> ligne duo (Klarna 3x + PayPal 4x)
       20 EUR a 35 EUR, et
       1 500,01 EUR a 3 000 EUR -> ligne PayPal seul
       ailleurs                 -> rien */
  function paintKlarnaFr(line, cents) {
    var seul = (line.parentNode || document).querySelector('[data-cm-pf-seul]');
    var min = parseInt(line.getAttribute('data-klarna-min-cents'), 10);
    var max = parseInt(line.getAttribute('data-klarna-max-cents'), 10);
    var pmin = parseInt(line.getAttribute('data-pp-min-cents'), 10);
    var pmax = parseInt(line.getAttribute('data-pp-max-cents'), 10);
    var okK = !isNaN(min) && !isNaN(max) && cents >= min && cents <= max;
    var okP = !isNaN(pmin) && !isNaN(pmax) && cents >= pmin && cents <= pmax;
    line.style.display = (okK && okP) ? '' : 'none';
    if (seul) seul.style.display = (!okK && okP) ? '' : 'none';
    if (okK && okP) {
      paintEcheance(document.getElementById('casemira-klarna-installment'), Math.ceil(cents / 3));
      paintEcheance(line.querySelector('[data-cm-pf-p]'), Math.ceil(cents / 4));
    } else if (okP && seul) {
      paintEcheance(seul.querySelector('[data-cm-pf-p]'), Math.ceil(cents / 4));
    }
  }

  /* ★ C1 VAGUE 9, point 2 · LA VARIANTE SE RESOUT PAR L'ENSEMBLE DES OPTIONS
     ------------------------------------------------------------------------
     `sameOptions` compare deux combinaisons ; `resolveWith` prend la
     combinaison courante, y remplace UNE option, et cherche la variante
     correspondante. Quand la combinaison exacte n'existe pas (un format qui
     n'est pas decline dans la forme choisie), on garde l'option qui vient de
     changer et on retombe sur la meilleure des autres, disponible d'abord :
     c'est exactement ce que fait Shopify quand on change une option dans un
     selecteur natif. */
  function sameOptions(a, b) {
    if (!a || !b || a.length !== b.length) return false;
    for (var i = 0; i < a.length; i++) {
      if (String(a[i]).trim() !== String(b[i]).trim()) return false;
    }
    return true;
  }

  function currentOptions() {
    var cat = catalogue();
    if (!cat) return null;
    var cur = cat.byId[currentVariantId()];
    if (cur) return cur.options.slice();
    return cat.list.length ? cat.list[0].options.slice() : null;
  }

  /* `from` : la combinaison de depart. Elle vaut par defaut celle de la
     variante courante, mais `paintPickerState` doit passer celle qu'il est en
     train de peindre : au moment ou il tourne, `input[name="id"]` porte encore
     l'ancienne variante (paintInputs vient apres), et les pastilles seraient
     rattachees a la forme precedente. Defaut trouve a la mesure du 22/08, sur
     la fiche 2 x 2 rejouee. */
  function resolveWith(index, value, from) {
    var cat = catalogue();
    if (!cat) return null;
    var base = from ? from.slice() : currentOptions();
    if (!base) return null;
    var want = base.slice();
    want[index] = value;

    var exact = null, best = null, bestScore = -1;
    cat.list.forEach(function (o) {
      if (String(o.options[index] || '').trim() !== String(value).trim()) return;
      if (!exact && sameOptions(o.options, want)) exact = o;
      var score = 0;
      for (var i = 0; i < want.length; i++) {
        if (i !== index && String(o.options[i] || '').trim() === String(want[i] || '').trim()) score += 2;
      }
      if (o.available) score += 1;
      if (score > bestScore) { bestScore = score; best = o; }
    });
    return exact || best;
  }

  /* La combinaison lue dans les selecteurs natifs du thème, groupe par groupe.
     C'est ce qui permet de repondre instantanement a un changement d'option
     qui ne vient PAS du selecteur de taille (la forme, par exemple). */
  function optionsFromInputs() {
    var host = scope();
    var cat = catalogue();
    if (!host || !cat) return null;
    /* Le thème insere le nouveau `<variant-selects>` DEVANT l'ancien et masque
       ce dernier pendant 500 ms (theme.js, viewTransition) : on lit toujours le
       DERNIER visible, jamais le fantome. */
    var all = Array.prototype.slice.call(host.querySelectorAll('variant-selects'));
    var vs = null;
    for (var k = all.length - 1; k >= 0; k--) {
      if (all[k].style.display !== 'none') { vs = all[k]; break; }
    }
    if (!vs) return null;
    var out = currentOptions();
    if (!out) return null;
    for (var i = 0; i < cat.optionNames.length; i++) {
      var pos = i + 1;
      var r = vs.querySelector('input[type="radio"][name$="-' + pos + '"]:checked');
      if (r) { out[i] = r.value; continue; }
      var sel = vs.querySelector('select[name$="-' + pos + '"]');
      if (sel) out[i] = sel.value;
    }
    return out;
  }

  function byOptions(opts) {
    var cat = catalogue();
    if (!cat || !opts) return null;
    for (var i = 0; i < cat.list.length; i++) {
      if (sameOptions(cat.list[i].options, opts)) return cat.list[i];
    }
    return null;
  }

  /* Les selecteurs natifs, mis en phase TOUT DE SUITE. Sur une fiche a une
     seule option, `selectRow()` de casemira-dropdown-size-picker.js le fait
     deja et on ne le refait pas : ce fichier ne prend la main que la ou
     l'autre ne peut pas repondre (le libelle d'une variante a deux options,
     « 160 x 230 cm / Rectangulaire », ne correspond a aucune valeur de radio). */
  var pushingOptions = false;

  function pushOptionInputs(v) {
    var host = scope();
    var cat = catalogue();
    if (!host || !cat) return;
    var all = Array.prototype.slice.call(host.querySelectorAll('variant-selects'));
    var vs = null;
    for (var k = all.length - 1; k >= 0; k--) {
      if (all[k].style.display !== 'none') { vs = all[k]; break; }
    }
    if (!vs) return;
    pushingOptions = true;
    try {
      for (var i = 0; i < v.options.length; i++) {
        var pos = i + 1;
        var val = v.options[i];
        var radios = vs.querySelectorAll('input[type="radio"][name$="-' + pos + '"]');
        var changed = false;
        for (var j = 0; j < radios.length; j++) {
          var want = radios[j].value.trim() === String(val).trim();
          if (radios[j].checked !== want) { radios[j].checked = want; if (want) changed = true; }
        }
        if (changed) {
          var on = vs.querySelector('input[type="radio"][name$="-' + pos + '"]:checked');
          if (on) on.dispatchEvent(new Event('change', { bubbles: true }));
          continue;
        }
        var sel = vs.querySelector('select[name$="-' + pos + '"]');
        if (sel && sel.value !== val) {
          sel.value = val;
          sel.dispatchEvent(new Event('change', { bubbles: true }));
        }
      }
    } finally {
      pushingOptions = false;
    }
  }

  /* La valeur d'option que porte une ligne du selecteur. */
  function rowSizeValue(row) {
    if (row.__cmSize) return row.__cmSize;
    return (row.getAttribute('data-size-value') || '').trim();
  }

  function paintPickerState(v) {
    var cat = catalogue();
    if (!cat || !cat.picker) return;
    var picker = cat.picker;
    var flat = picker.classList.contains('dw-picker--flat');
    var rows = cat.rows;

    rows.forEach(function (row) {
      var dim = row.classList.contains('dimension-btn');
      /* Sur une fiche a plusieurs options, la ligne ne represente plus une
         variante mais une VALEUR de l'option dimension : la variante qui lui
         correspond depend de la forme choisie, et change avec elle. */
      var sizeVal = rowSizeValue(row);
      var target = cat.multi
        ? resolveWith(cat.sizeIndex, sizeVal, v.options)
        : cat.byId[String(row.getAttribute('data-variant-id'))];
      if (target && String(row.getAttribute('data-variant-id')) !== target.id) {
        row.setAttribute('data-variant-id', target.id);
      }
      var isActive = target ? target.id === v.id : String(row.getAttribute('data-variant-id')) === v.id;

      if (dim) {
        row.classList.toggle('is-selected', isActive);
        /* La disponibilite suit la combinaison, pas le rendu serveur. */
        if (target) {
          row.classList.toggle('is-unavailable', !target.available);
          if (target.available) row.removeAttribute('disabled');
          else row.setAttribute('disabled', 'disabled');
          var st = row.querySelector('.dimension-btn__stock');
          if (st && !row.classList.contains('has-scarcity')) {
            setText(st, target.available ? (S.enStock || 'En stock') : soldOutLabel());
          }
          var pr = row.querySelector('.dimension-btn__price');
          if (pr && target.priceText) setText(pr, target.priceText);
          if (cat.formIndex >= 0 && target.options[cat.formIndex] != null) {
            row.setAttribute('data-form-value', target.options[cat.formIndex]);
          }
        }
        return;
      }

      row.classList.toggle('dw-picker__row--active', isActive);
      row.setAttribute(row.getAttribute('role') === 'radio' ? 'aria-checked' : 'aria-selected', isActive ? 'true' : 'false');
      if (target) {
        row.classList.toggle('dw-picker__row--oos', !target.available);
        row.setAttribute('data-available', target.available ? 'true' : 'false');
        if (target.available) {
          row.removeAttribute('aria-disabled');
          row.removeAttribute('data-cm-oos');
        } else {
          row.setAttribute('aria-disabled', 'true');
          row.setAttribute('data-cm-oos', 'true');
        }
      }
      if (flat) {
        row.setAttribute('aria-checked', isActive ? 'true' : 'false');
        /* Tabulation glissante : un seul arret de tabulation pour tout le
           groupe, celui du format choisi. C'est la regle du motif radiogroup :
           la touche Tab entre et sort du groupe, les fleches circulent dedans. */
        row.setAttribute('tabindex', isActive ? '0' : '-1');
      }
      if (row.hasAttribute('aria-pressed')) {
        row.setAttribute('aria-pressed', isActive ? 'true' : 'false');
      }
    });

    /* Etat ferme du tiroir : taille, disponibilite et prix suivent aussi. */
    var dimEl = picker.querySelector('.dw-picker__trigger-dim');
    var price = picker.querySelector('.dw-picker__trigger-price');
    if (dimEl) setText(dimEl, v.size);
    if (price && v.priceText) setText(price, v.priceText);
    var dot = picker.querySelector('.dw-picker__trigger .dw-picker__mid');
    var stock = picker.querySelector('.dw-picker__trigger .dw-picker__stk');
    if (dot) dot.className = 'dw-picker__mid dw-picker__mid--' + (v.available ? 'in' : 'out');
    if (stock) {
      stock.className = 'dw-picker__stk dw-picker__stk--' + (v.available ? 'in' : 'out');
      setText(stock, v.available ? (S.enStock || 'En stock') : soldOutLabel());
    }
  }

  function paintInputs(v) {
    document.querySelectorAll(SECTION + ' form input[name="id"]').forEach(function (input) {
      if (input.value !== v.id) input.value = v.id;
    });
  }

  function paintUrl(v) {
    var pi = document.querySelector('product-info');
    if (!pi || pi.getAttribute('data-update-url') === 'false') return;
    /* Rien n'a change depuis le rendu serveur et l'adresse d'arrivee ne portait
       pas de variante : on ne la salit pas. Le theme se comporte de la meme
       facon, il n'ecrit l'URL qu'au premier changement. */
    if (v.id === INITIAL_ID && !/[?&]variant=/.test(INITIAL_SEARCH)) return;
    var cat = catalogue();
    var base = (cat && cat.url) || location.pathname;
    /* On REECRIT le parametre `variant`, on ne reconstruit pas l'adresse. Le
       theme, lui, ecrit `url + '?variant=' + id` et jette tout le reste :
       `utm_*`, `preview_theme_id`, l'identifiant de campagne. On ne va pas
       reproduire ce defaut 250 ms plus tot. */
    var params;
    try { params = new URLSearchParams(location.search); } catch (e) { return; }
    if (params.get('variant') === v.id) return;
    params.set('variant', v.id);
    var want = base + '?' + params.toString();
    if (location.pathname + location.search === want) return;
    try {
      /* `replaceState` et non `pushState` : le format n'est pas une page, et le
         bouton « precedent » doit ramener a la page d'ou l'on vient. Aucun
         defilement n'est provoque : c'est la difference avec un lien. */
      history.replaceState(history.state, '', want);
    } catch (e) {}
  }

  /* ------------------------------------------------------------------------
     Rarete : une seule ligne, sous le selecteur, pour le format choisi
     ------------------------------------------------------------------------
     assets/casemira-scarcity-stock.js remplace, DANS deux lignes au plus, le
     « En stock » par « Plus que X en stock » et le point vert par un point
     ambre. Ce libelle deborde de la pastille en grille a plat, et il encombre
     la carte de 56 px de l'etat ferme du tiroir : le CSS le masque aux deux
     endroits (assets/casemira-size-picker.css) et on le rappelle ici, une fois,
     SOUS le selecteur, pour le format SELECTIONNE seulement (VAGUE 5, point 3 :
     pour les deux densites, et sans aucun point).

     ── DEUX SOURCES, ET LE REEL PASSE DEVANT ──
     Le bloc JSON des variantes publie desormais `scarcity` : le SEUIL de rarete
     REELLE d'une variante a stock suivi (1, 2 ou 3 exemplaires restants,
     politique deny), null partout ailleurs. C'est le cas des fiches Carpet
     Decor, dont le stock Shopify est vrai et dont aucune ne porte l'etiquette
     `scarcity`.

     Quand ce chiffre existe pour la variante choisie, c'est LUI qui s'ecrit, et
     la rarete virtuelle ne tourne meme pas : snippets/dropdown-size-picker.liquid
     pose `data-cm-real-stock="true"` et assets/casemira-scarcity-stock.js sort
     immediatement. Sinon, rien ne change : on lit le libelle que ce widget a
     ecrit DANS la ligne active, exactement comme avant.

     Le chiffre reel ne se lit PAS dans la ligne, et c'est le point : une ligne
     est reaffectee a une autre variante quand la forme change
     (`row.setAttribute('data-variant-id', ...)` dans paintPickerState). La
     variante, elle, porte son chiffre pour toute la page.

     Le rendu est le meme dans les deux cas, au caractere pres :
     `<p class="dw-picker__scarcity"><span class="dw-scarcity-label">Plus que
     <strong>2</strong> en stock</span></p>`. */

  /* La phrase, dans la langue de la page : LA MEME CLE que la rarete virtuelle,
     `stock_plus_que` (assets/casemira-scarcity-stock.js l.84), avec le
     `<strong>` pose par le code autour du nombre. Relecture Astra du 15/09 :
     la cle `scarcity_plus_que_html` disait « Only 3 left » en anglais quand le
     virtuel dit « Only 3 left in stock » ; une seule cle, un seul texte, dans
     les quatre langues. Elle reste en repli si l'autre manquait.
     Dernier repli en dur : une phrase francaise vaut mieux qu'un `undefined`. */
  function scarcityHtml(n) {
    if (S.stockPlusQue) return avec(S.stockPlusQue, '[n]', '<strong>' + n + '</strong>');
    if (S.scarcityPlusQue) return avec(S.scarcityPlusQue, '[n]', n);
    return 'Plus que <strong>' + n + '</strong> en stock';
  }

  function scarcityLine(picker, activeRow, v) {
    var line = picker.querySelector('.dw-picker__scarcity');
    var html = '';

    if (v && v.available && typeof v.scarcity === 'number' && v.scarcity >= 1 && v.scarcity <= 3) {
      html = scarcityHtml(v.scarcity);
    } else {
      var src =
        activeRow && activeRow.getAttribute('data-has-scarcity') === 'true' &&
        activeRow.getAttribute('data-available') === 'true'
          ? activeRow.querySelector('.dw-scarcity-label')
          : null;
      if (src) html = src.innerHTML;
    }

    if (!html.trim()) {
      if (line) line.remove();
      return;
    }
    if (!line) {
      line = document.createElement('p');
      line.className = 'dw-picker__scarcity';
      line.innerHTML = '<span class="dw-scarcity-label"></span>';
      picker.appendChild(line);
    }
    /* Ceinture : une ligne heritee d'un rendu precedent peut encore porter le
       point. On le retire plutot que de compter sur le seul CSS. */
    var oldDot = line.querySelector('.dw-scarcity-dot');
    if (oldDot) oldDot.remove();
    var lbl = line.querySelector('.dw-scarcity-label');
    if (lbl.innerHTML !== html) lbl.innerHTML = html;
  }

  var painting = false;
  /* La derniere variante que ce fichier a peinte. Elle sert a la garde des
     noeuds visibles (voir guardVisibleNodes) : quand le re-rendu du thème
     remplace le bloc de prix, on repose ce qui etait deja a l'ecran. */
  var LAST_PAINTED = null;

  function paint(id) {
    if (painting) return;
    var cat = catalogue();
    if (!cat) return;
    var v = cat.byId[String(id)];
    if (!v) return;
    painting = true;
    LAST_PAINTED = v.id;
    try {
      paintPickerState(v);
      paintPrice(v);
      paintButton(v);
      paintKlarna(v);
      paintInputs(v);
      paintUrl(v);
      if (cat.picker) scarcityLine(cat.picker, v.row, v);
      if (v.available) clearOosLine();
      /* Un seul evenement, pour tout ce qui vit dans les autres fichiers de la
         fiche (la barre collante mobile, assets/casemira-pdp-layout.js). On ne
         reutilise pas `variant:changed` : il appartient au theme, et le
         confondre avec celui-ci rendrait impossible de distinguer « repeint
         sans reseau » de « confirme par le serveur ». */
      document.dispatchEvent(new CustomEvent('cm:variant:instant', {
        detail: { id: v.id, size: v.size, price: v.priceMoney, available: v.available }
      }));
    } finally {
      painting = false;
    }
  }

  function sync(force) {
    var id = force ? String(force) : currentVariantId();
    if (!id) return;
    paint(id);
  }

  /* ------------------------------------------------------------------------
     3 · Proteger la galerie du re-rendu du theme
     ------------------------------------------------------------------------
     product-info.js appelle `updateMedia(variant)` a CHAQUE changement, et
     `updateMedia` appelle `productMedia.init()` : le carrousel Swiper est
     reconstruit, meme quand la variante ne porte aucun media propre, ce qui est
     le cas de tous les formats d'un meme tapis. C'est la seule zone du
     re-rendu qui touche a un noeud visible et volumineux.

     Mesure du 22/08 : la hauteur de la galerie ne bouge pas (0,0 px d'ecart sur
     4 s de sondage a 4 ms, en 430 et en 1440), donc il n'y a pas de saut de
     mise en page a corriger. Ce qui reste est un travail inutile au pire moment
     (le tour d'evenement qui suit le tap). On le supprime quand, et seulement
     quand, le media de la variante est le meme qu'avant.

     On n'ecrit pas dans assets/product-info.js : on remplace la methode sur
     l'INSTANCE, ce qui laisse la classe du theme intacte et se defait tout seul
     si l'element est remplace. */
  function mediaGuard() {
    var pi = document.querySelector('product-info');
    if (!pi || pi.__cmMediaGuard || typeof pi.updateMedia !== 'function') return;
    pi.__cmMediaGuard = 1;
    var last = '';
    try {
      var sel = pi.querySelector('variant-selects [data-selected-variant]');
      var j = sel ? JSON.parse(sel.textContent) : null;
      last = (j && j.featured_media && j.featured_media.id) ? String(j.featured_media.id) : '';
    } catch (e) { last = ''; }
    var orig = pi.updateMedia.bind(pi);
    pi.updateMedia = function (variant) {
      var mid = (variant && variant.featured_media && variant.featured_media.id)
        ? String(variant.featured_media.id) : '';
      if (mid === last) return;
      last = mid;
      /* ★ C1 VAGUE 10, point 2 : LA PHOTO NE PART PAS AVANT QUE L'AUTRE SOIT LA.
         Ici la variante porte VRAIMENT une autre photo : l'appel doit passer.
         Mais `updateMedia()` fait glisser le carrousel tout de suite, et si la
         photo d'arrivee n'est pas encore decodee, on voit son cadre vide, donc
         du blanc, le temps d'un decodage. On attend donc `img.decode()` avant
         de laisser passer l'appel.

         Trois garde-fous, et ils comptent plus que le principe :
           - si la photo est deja decodee, `decode()` resout dans la microtache
             suivante : le glissement reste dans le meme tour, on ne paie rien ;
           - si elle echoue (404, format refuse), on laisse passer quand meme :
             mieux vaut le comportement du thème qu'une photo qui ne change
             jamais ;
           - un delai de garde de 300 ms borne l'attente : sur un reseau lent le
             carrousel glisse sans elle, comme avant.

         AUCUN PRODUIT DE LA BOUTIQUE N'EMPRUNTE CE CHEMIN AUJOURD'HUI. Releve
         du 22/08 sur `/products/<handle>.json` : aucune variante de Sahel, de
         Valore beige ni de Valore rouge-caramel ne porte de `featured_image`.
         L'hypothese « la photo change par format » du brief est donc ecartee
         par la mesure ; la garde est posee pour le jour ou une fiche en portera
         une, et elle est eprouvee par simulation (voir VAGUE-10.md). */
      var img = mediaImage(pi, mid);
      if (!img || typeof img.decode !== 'function') return orig(variant);
      /* PIEGE MESURE LE 22/08. Les photos de la galerie sont PARESSEUSES : hors
         de la premiere, aucune n'a encore de source. `decode()` reste alors en
         attente indefiniment, et le delai de garde de 300 ms devenait la regle
         au lieu de l'exception (mesure : le glissement arrivait a 302 ms). On
         demande donc la photo avant de l'attendre. */
      if (img.loading === 'lazy') img.loading = 'eager';
      var passe = false;
      var laisserPasser = function () { if (passe) return; passe = true; orig(variant); };
      setTimeout(laisserPasser, 300);
      img.decode().then(laisserPasser, laisserPasser);
    };
  }

  /* La photo d'arrivee, telle qu'elle est deja ecrite dans la galerie. On ne
     fabrique pas une seconde requete : c'est le meme element, donc le meme
     cache, donc le meme decodage que celui que le carrousel montrera. */
  function mediaImage(pi, mid) {
    if (!mid) return null;
    var item = pi.querySelector('[data-media-id$="-' + mid + '"], [data-media-id="' + mid + '"]');
    return item ? item.querySelector('img') : null;
  }

  /* ------------------------------------------------------------------------
     4 · Le format epuise (VAGUE 7, point 2, revu le 22/08 a 12h25)
     ------------------------------------------------------------------------
     Une pastille epuisee ne portait plus `disabled` (voir le Liquid) : c'est ce
     qui permet de repondre au geste. Trois choses se produisent, et rien de
     plus :
       1. la pastille vibre horizontalement, 2 × 3 px, 200 ms, en `transform`
          seul (DESIGN.md, regle Transform ou Rien) et rien du tout sous
          `prefers-reduced-motion` ;
       2. une ligne s'ecrit sous la grille : « 120 × 170 cm épuisé · Le format
          le plus proche : 160 × 230 cm · 229 € → ». Le lien choisit ce format,
          par le meme chemin qu'un clic sur la pastille, donc instantanement ;
       3. si, et seulement si, le produit annonce un reassort (etiquette
          `reassort-prevu` ou metachamp `custom.reassort_prevu`), la ligne
          propose en plus d'etre prevenu. Sans cette condition, on ne promet
          rien : une alerte sur un format qui ne reviendra pas est une promesse
          qu'on ne tient pas.
     ---------------------------------------------------------------------- */
  function isOos(row) {
    return !!row && (row.getAttribute('data-available') === 'false'
      || row.getAttribute('aria-disabled') === 'true'
      || row.classList.contains('dw-picker__row--oos'));
  }

  function shake(row) {
    if (reducedMotion()) return;
    row.classList.remove('dw-picker__row--refuse');
    /* Forcer un reflux : sans cela, retirer puis remettre la classe dans le
       meme tour ne redemarre pas l'animation. */
    void row.offsetWidth;
    row.classList.add('dw-picker__row--refuse');
    setTimeout(function () { row.classList.remove('dw-picker__row--refuse'); }, 260);
  }

  /* Le format disponible le plus proche, s'il y en a un qui merite d'etre
     propose. Trois regles, dans cet ordre :
       1. meme forme (un rond ne remplace pas un rectangle) ;
       2. surface comprise entre NEAR_MIN_RATIO et NEAR_MAX_RATIO fois celle du
          format demande ; hors de la, on ne propose rien ;
       3. parmi les restants, le plus proche EN RATIO de surface (et non en
          difference brute : entre un 40 × 60 et un 300 × 400, la difference
          brute ferait toujours gagner le plus petit ecart absolu, qui n'a aucun
          sens a cette echelle). A egalite de ratio, le plus grand. */
  function nearestAvailable(v) {
    var cat = catalogue();
    if (!cat || !v.area) return null;
    var best = null, bestD = Infinity;
    cat.list.forEach(function (o) {
      if (!o.available || o.id === v.id || !o.area) return;
      if (o.shape !== v.shape) return;
      var ratio = o.area / v.area;
      if (ratio < NEAR_MIN_RATIO || ratio > NEAR_MAX_RATIO) return;
      var d = ratio >= 1 ? ratio : 1 / ratio;
      if (d < bestD || (d === bestD && best && o.area > best.area)) { best = o; bestD = d; }
    });
    return best;
  }

  function clearOosLine() {
    var el = document.querySelector(SECTION + ' .dw-picker__oos');
    if (!el) return;
    var picker = el.closest ? el.closest('.dw-picker') : null;
    el.remove();
    /* VAGUE 10 : la ligne rendait 42 px au panneau en partant, le palier doit
       les rendre a la liste. Mais `clearOosLine()` est appelee depuis
       `paint()`, donc sur le chemin critique du changement de format : mesurer
       des rectangles la coute un calcul de mise en page force. On ne le fait
       donc QUE si la feuille est ouverte (le seul cas ou le palier existe), et
       a l'image suivante, hors du chemin. Mesure : sans cette garde, Valore
       passait de 20,9 a 33,2 ms entre le tap et la repeinture complete. */
    if (picker && isSheetOpen(picker) && window.requestAnimationFrame) {
      requestAnimationFrame(function () { applyPeek(picker); });
    }
  }

  /* ------------------------------------------------------------------------
     ★ C1 VAGUE 8, point 3 : la reponse doit etre VISIBLE, tiroir ouvert
     ------------------------------------------------------------------------
     Mesure du 22/08, iPhone 430, Valore, tiroir ouvert : la ligne se posait
     sous le selecteur, a y = 502, et la feuille basse commence a y = 755 avec
     un voile par-dessus le reste. Elle etait donc ecrite DERRIERE la feuille :
     le tap sur un format epuise vibrait, et rien d'autre ne se voyait. Un
     geste sans reponse visible est un geste sans reponse.

     La ligne suit donc le composant : quand la feuille basse est ouverte
     (drawer, sous 750 px, `is-open`), elle se pose DANS le panneau, juste sous
     l'en-tete colle, au-dessus de la liste ; sinon elle revient a sa place
     historique, sous le selecteur ferme, au-dessus de la ligne de rarete.
     C'est le meme element, le meme `role="status"`, le meme texte : il change
     de parent, pas de nature.

     En desktop le panneau est un menu deroulant pose SOUS le declencheur : la
     ligne, qui vit au-dessus de lui, est deja visible (mesuree a y = 486 pour
     un panneau a y = 510). Rien n'y change.
     ------------------------------------------------------------------------ */
  function isSheetOpen(picker) {
    return !!picker
      && picker.classList.contains('dw-picker--drawer')
      && picker.classList.contains('is-open')
      && window.matchMedia('(max-width: 749px)').matches;
  }

  function placeOosLine(picker, line) {
    if (!picker) return;
    line = line || picker.querySelector('.dw-picker__oos');
    if (!line) return;

    if (isSheetOpen(picker)) {
      var panel = picker.querySelector('.dw-picker__panel');
      var scroll = picker.querySelector('.dw-picker__scroll');
      if (panel && scroll && line.parentNode !== panel) {
        panel.insertBefore(line, scroll);
      }
      return;
    }
    if (line.parentNode !== picker) {
      var scar = picker.querySelector('.dw-picker__scarcity');
      if (scar) picker.insertBefore(line, scar);
      else picker.appendChild(line);
    }
  }

  /* ------------------------------------------------------------------------
     5 bis · La feuille dit qu'elle continue (VAGUE 10, point 1)
     ------------------------------------------------------------------------
     LE DEFAUT, MESURE AVANT DE CODER. La vague 9 a rendu la liste defilable et
     l'a plafonnee a 70 vh. Releve du 22/08, lignes de 48 px, en-tete de feuille
     mesure a 77 px :

       Valore rouge-caramel, 13 formats, 430 x 932
         panneau 652,4 px (70 vh), liste 574,4 px = 11,97 lignes
         -> la 12e ligne etait visible a 97 %

       Valore rouge-caramel, 13 formats, 390 x 844
         panneau 590,8 px (70 vh), liste 512,8 px = 10,68 lignes

     A 430, l'oeil lisait donc douze lignes entieres et un filet, et concluait
     qu'il n'y avait plus rien. C'est exactement la crainte du proprietaire :
     un alignement presque parfait ment mieux qu'une coupe franche.

     QUATRE CHOSES, ENSEMBLE, ET AUCUNE NE SUFFIT SEULE.
       a) la feuille s'ouvre a un PALIER calcule pour couper une ligne EN SON
          MILIEU. On part de la moitie de la fenetre, puis on descend au demi-pas
          de ligne le plus proche : `liste = (k + 0,5) x hauteurDeLigne`. Une
          demi-ligne qui depasse ne peut pas se lire comme une fin de liste.
       b) un fondu de 40 px efface le bas de la liste tant qu'on n'est pas en
          bas (un MASQUE, pas un degrade peint : voir le CSS) ;
       c) l'en-tete porte « 13 formats · faites defiler », et le suffixe tombe
          des qu'on a touche le bas : « 13 formats » ;
       d) l'ascenseur passe en `thin`, pouce en encre a 30 % (CSS).

     LE PALIER NE S'APPLIQUE QUE S'IL Y A QUELQUE CHOSE A ANNONCER. Quand la
     liste entiere tient sous les 70 vh de la vague 9, aucun palier n'est pose,
     aucun fondu, aucun suffixe : la feuille s'ouvre en entier, comme la vague 1
     le voulait. Mesure : Valore beige, 11 formats, 430 x 932 -> 605 px, tout
     tient, `--dw-peek` n'est pas ecrit.

     TOUT EST MESURE, RIEN N'EST DEVINE. La hauteur d'une ligne est lue sur la
     premiere ligne ; ce que le panneau porte hors de la liste (l'en-tete colle,
     et la ligne « format proche » de la vague 8 quand elle est la) est la somme
     mesuree de ses autres enfants. Le calcul en trois valeurs devinees de la
     vague 8 ne revient pas par la fenetre.
     ------------------------------------------------------------------------ */
  var PEEK_VH = 0.5;        /* palier de depart : la moitie de la fenetre     */
  var PEEK_CEIL_VH = 0.7;   /* le plafond de la vague 9, inchange             */
  var PEEK_MIN_ROWS = 2;    /* jamais moins de deux lignes et demie           */

  function sheetParts(picker) {
    if (!picker || !picker.classList.contains('dw-picker--drawer')) return null;
    var panel = picker.querySelector('.dw-picker__panel');
    var scroll = picker.querySelector('.dw-picker__scroll');
    if (!panel || !scroll) return null;
    var rows = scroll.querySelectorAll('.dw-picker__row');
    if (!rows.length) return null;
    return { panel: panel, scroll: scroll, rows: rows };
  }

  /* Ce que le panneau porte hors de la liste. Somme mesuree de ses autres
     enfants : l'en-tete colle, et la ligne « format proche » quand la vague 8
     l'a posee la. Un enfant masque mesure zero, il ne fausse rien. */
  function sheetChrome(parts) {
    var h = 0;
    Array.prototype.forEach.call(parts.panel.children, function (el) {
      if (el === parts.scroll) return;
      h += el.getBoundingClientRect().height;
    });
    return h;
  }

  function measurePeek(picker) {
    var parts = sheetParts(picker);
    if (!parts) return null;
    var rh = parts.rows[0].getBoundingClientRect().height || parts.rows[0].offsetHeight;
    if (!(rh > 8)) return null;
    var chrome = sheetChrome(parts);
    var contenu = parts.rows.length * rh;
    var plafond = PEEK_CEIL_VH * window.innerHeight - chrome;
    /* Tout tient : rien a annoncer, donc aucun palier. */
    if (contenu <= plafond + 0.5) return { peek: null, lignes: parts.rows.length, coupee: 0 };
    var palier = PEEK_VH * window.innerHeight - chrome;
    var k = Math.floor(palier / rh - 0.5);
    if (k < PEEK_MIN_ROWS) k = PEEK_MIN_ROWS;
    /* Il faut qu'il reste une demi-ligne A COUPER : sans cela le palier
       retomberait pile entre deux lignes, ce qu'on cherche justement a eviter. */
    if (k > parts.rows.length - 1) k = parts.rows.length - 1;
    var liste = (k + 0.5) * rh;
    if (liste > plafond) liste = plafond;
    /* Deux decimales, et pas un entier : le hors-liste mesure 77,x px, et
       arrondir la somme decalait la coupe d'un pixel. Mesure du 22/08 a
       390 x 844 : la ligne coupee tombait a 0,48 de sa hauteur au lieu de 0,50,
       et la derniere ligne depassait de 1 px une fois la liste au bas. */
    return { peek: +(liste + chrome).toFixed(2), liste: liste, lignes: parts.rows.length, coupee: k + 1 };
  }

  /* Le fondu et le suffixe disent la meme chose, ils doivent donc toujours dire
     la meme chose : une seule fonction les pose et les retire. Les ecritures
     sont conditionnelles, sinon chaque passage produirait une mutation pour
     rien (voir la boucle de re-skin refermee dans casemira-pdp-reskin.js). */
  function paintScrollCue(picker) {
    var parts = sheetParts(picker);
    if (!parts) return;
    var defile = parts.scroll.scrollHeight > parts.scroll.clientHeight + 1;
    var enBas = !defile
      || parts.scroll.scrollTop + parts.scroll.clientHeight >= parts.scroll.scrollHeight - 1;
    var montrer = defile && !enBas;
    if (parts.scroll.classList.contains('dw-picker__scroll--fade') !== montrer) {
      parts.scroll.classList.toggle('dw-picker__scroll--fade', montrer);
    }
    var cue = picker.querySelector('.dw-picker__sheet-cue');
    if (cue && cue.hasAttribute('hidden') === montrer) {
      if (montrer) cue.removeAttribute('hidden');
      else cue.setAttribute('hidden', 'hidden');
    }
  }

  /* ★ C1 VAGUE 10, point 1 : CE QUI PASSAIT DEVANT LA LISTE.
     Trouve en photographiant la feuille : la pilule « Visualisez ce tapis chez
     vous » et les points du carrousel vivent dans la galerie, en `position:
     absolute`, et ils se posent PAR-DESSUS la feuille basse. Mesure du 22/08,
     Valore 430 x 932 : avant la vague 10 la pilule recouvrait « 90 × 310 cm »,
     apres elle recouvrait « 60 × 100 cm ». Le defaut est donc anterieur, mais
     il vise exactement ce que le point 1 cherche a corriger : un format qu'on
     ne voit pas. La feuille ouverte les efface, en `opacity` seule ; elle les
     rend en se fermant. */
  function markSheetOpen(picker) {
    var ouvert = isSheetOpen(picker);
    var root = document.documentElement;
    if (root.classList.contains('cm-sheet-open') !== ouvert) {
      root.classList.toggle('cm-sheet-open', ouvert);
    }
  }

  function applyPeek(picker, secondePasse) {
    picker = picker || document.querySelector(SECTION + ' .dw-picker--drawer');
    if (!picker) return;
    markSheetOpen(picker);
    /* Le palier est une reponse a une feuille basse : en desktop le panneau est
       un menu ancre, la vague 9 l'a deja plafonne a 70 vh et il n'y a pas
       d'en-tete de feuille ou ecrire quoi que ce soit. */
    var m = window.matchMedia('(max-width: 749px)').matches ? measurePeek(picker) : null;
    /* Le palier est ecrit en pixels, a deux decimales : le hors-liste mesure
       77,x px, et arrondir la somme decalait la coupe d'un pixel. Ce qui reste
       d'ecart apres cela est du sous-pixel de mise en page (mesure : 0,02 ligne
       au pire, soit un peu moins d'un pixel) ; on ne le corrige PAS. Une
       correction qui relit la hauteur obtenue pour la rendre a la feuille a ete
       ecrite, mesuree, et retiree : elle rendait le palier fractionnaire et
       faisait alors depasser la derniere ligne de 0,8 px une fois la liste en
       bas. Un demi-pixel de moins sur la coupe ne se voit pas ; une derniere
       ligne qui depasse, si. */
    if (m && m.peek) picker.style.setProperty('--dw-peek', m.peek + 'px');
    else picker.style.removeProperty('--dw-peek');
    paintScrollCue(picker);
    /* UNE SECONDE PASSE, ET UNE SEULE. La ligne « format proche » de la vague 8
       vient d'entrer dans le panneau : au moment du premier calcul elle n'a pas
       encore sa hauteur definitive (son texte se replie sur une ou deux lignes
       selon la largeur). Mesure du 22/08, Valore 430 x 932, tiroir ouvert, tap
       sur un format epuise : le hors-liste passait de 146 px a 131,4 px APRES
       le calcul, et la coupe glissait de 0,5 a 0,8 de ligne. La passe suivante
       remesure une fois, a l'image d'apres, et s'arrete la : `secondePasse`
       interdit la recursion. */
    if (!secondePasse && window.requestAnimationFrame) {
      requestAnimationFrame(function () { applyPeek(picker, true); });
    }
  }

  function watchSheetScroll(picker) {
    var parts = sheetParts(picker);
    if (!parts || parts.scroll.__cmCue) return;
    parts.scroll.__cmCue = 1;
    var enAttente = false;
    parts.scroll.addEventListener('scroll', function () {
      if (enAttente) return;
      enAttente = true;
      requestAnimationFrame(function () { enAttente = false; paintScrollCue(picker); });
    }, { passive: true });
    /* PIEGE MESURE LE 22/08, ET IL FAISAIT MENTIR LE FONDU.
       La feuille s'ouvre en animant `max-height` (c'est le thème d'origine) :
       pendant toute la duree de l'animation, la liste n'a pas encore sa
       hauteur, `clientHeight` vaut presque zero et « ca defile » est vrai meme
       quand tout tient. Valore beige, 11 formats, 430 x 932 : le fondu se
       posait sur une liste qui n'a rien a cacher. La reponse n'est pas un
       delai devine, c'est la fin de l'animation elle-meme. */
    parts.panel.addEventListener('transitionend', function (e) {
      if (e.propertyName === 'max-height') applyPeek(picker, true);
    });
  }

  /* Klaviyo : ce qui est reellement present dans la page, et rien d'autre.
     Releve du 22/08 sur la preview : `klaviyo.js`, `_klOnsite`, `klaviyo`,
     `__klKey` sont charges (app embed « klaviyo-onsite-embed », voir
     config/settings_data.json), mais AUCUN dispositif Back in Stock : ni
     formulaire dans le thème, ni `KlaviyoSubscribe`, ni point d'accroche
     `data-klaviyo-bis`. On branche donc ce qui existe, s'il apparait un jour,
     et on n'invente aucun appel d'API vers un service qu'on ne peut pas tester. */
  function klaviyoBackInStock() {
    var el = document.querySelector(
      '[data-klaviyo-bis], .klaviyo-bis-trigger, #klaviyo-bis-trigger,'
      + ' [id*="klaviyo" i][id*="stock" i], [class*="klaviyo" i][class*="stock" i]'
    );
    if (el) return { kind: 'dom', el: el };
    if (window.KlaviyoSubscribe && typeof window.KlaviyoSubscribe.attachToForms === 'function') {
      return { kind: 'subscribe' };
    }
    var k = window.klaviyo;
    if (k && typeof k.openBackInStockForm === 'function') {
      /* PIEGE MESURE LE 22/08. L'objet `klaviyo` pose par l'app embed est un
         relais qui renvoie une fonction pour N'IMPORTE QUEL nom de propriete :
         `typeof klaviyo.openBackInStockForm === 'function'` est vrai meme quand
         Back in Stock n'est pas installe, et la premiere version de ce fichier
         affichait donc « Être prévenu du retour » sur une fiche ou rien ne
         pouvait prevenir personne. On sonde avec un nom qui ne peut pas
         exister : s'il repond aussi, c'est le relais, pas la fonctionnalite. */
      var probe = k['cmProbe' + Math.random().toString(36).slice(2)];
      if (typeof probe !== 'function') return { kind: 'api' };
    }
    return null;
  }

  function refuse(row) {
    var cat = catalogue();
    if (!cat || !cat.picker) return;
    var v = cat.byId[String(row.getAttribute('data-variant-id'))];
    if (!v) return;

    shake(row);

    var line = cat.picker.querySelector('.dw-picker__oos');
    if (!line) {
      line = document.createElement('p');
      line.className = 'dw-picker__oos';
      line.setAttribute('role', 'status');
      cat.picker.appendChild(line);
    }
    /* VAGUE 8 : sous la feuille basse ouverte, la ligne se pose DANS le
       panneau ; sinon sous le selecteur. Voir placeOosLine. */
    placeOosLine(cat.picker, line);
    applyPeek(cat.picker);

    var near = nearestAvailable(v);
    var html;
    if (near) {
      html = avec(S.oosEpuise || '[t] épuisé', '[t]',
                  '<span class="dw-picker__oos-size">' + v.size + '</span>')
        + '<span class="dw-picker__oos-sep">·</span>'
        + '<button type="button" class="dw-picker__oos-link" data-cm-goto="' + near.id + '">'
        + avec(S.oosPlusProche || 'Le format le plus proche : [t]', '[t]',
               '<strong>' + near.size + '</strong>')
        + '<span class="dw-picker__oos-sep">·</span>' + near.priceText
        + ' <span class="dw-picker__oos-arrow" aria-hidden="true">→</span></button>';
    } else {
      /* Rien a proposer dans la fourchette : on le dit, et on s'arrete la. Une
         suggestion hors d'echelle serait pire que le silence. */
      html = S.oosCeFormat || 'Ce format est épuisé.';
    }
    if (cat.reassort) {
      html += klaviyoBackInStock()
        ? '<span class="dw-picker__oos-sep">·</span><button type="button" class="dw-picker__oos-link" data-cm-notify="' + v.id + '">' + (S.oosPrevenir || 'Être prévenu du retour') + ' <span class="dw-picker__oos-arrow" aria-hidden="true">→</span></button>'
        : '<span class="dw-picker__oos-sep">·</span><span class="dw-picker__oos-note">' + (S.oosReassort || 'Réassort prévu') + '</span>';
    }
    if (line.innerHTML !== html) line.innerHTML = html;
  }

  /* Le formulaire d'alerte n'existe que si un dispositif Back in Stock existe
     vraiment (voir klaviyoBackInStock). On lui delegue : on ne poste pas nous
     memes vers un service tiers. */
  function openNotify(btn, id) {
    var bis = klaviyoBackInStock();
    if (!bis) return;
    var line = btn.closest('.dw-picker__oos');
    if (!line) return;
    if (bis.kind === 'dom') { bis.el.click(); return; }
    if (bis.kind === 'api') { window.klaviyo.openBackInStockForm({ variant: id }); return; }
    var form = line.parentNode.querySelector('.dw-picker__notify');
    if (form) { form.querySelector('input').focus(); return; }
    form = document.createElement('form');
    form.className = 'dw-picker__notify';
    form.setAttribute('data-cm-variant', id);
    form.innerHTML =
      '<label class="dw-picker__notify-label" for="cm-bis-mail">' + (S.notifyLabel || 'Votre adresse e-mail') + '</label>'
      + '<div class="dw-picker__notify-row">'
      + '<input type="email" id="cm-bis-mail" name="email" required autocomplete="email" placeholder="' + (S.notifyExemple || 'vous@exemple.fr') + '">'
      + '<button type="submit">' + (S.notifyBouton || 'Me prévenir') + '</button>'
      + '</div>';
    line.parentNode.insertBefore(form, line.nextSibling);
    window.KlaviyoSubscribe.attachToForms(form, { hide_form_on_success: true });
    form.querySelector('input').focus();
  }

  /* ------------------------------------------------------------------------
     5 · Navigation au clavier des pastilles (VAGUE 7, point 3)
     ---------------------------------------------------------------------- */
  function isFlat(row) {
    var p = row.closest('.dw-picker');
    return !!p && p.classList.contains('dw-picker--flat');
  }

  function moveFocus(row, key) {
    var cat = catalogue();
    if (!cat) return;
    var rows = cat.rows;
    var i = rows.indexOf(row);
    if (i < 0) return;
    var n = rows.length;
    var j = i;
    if (key === 'ArrowRight' || key === 'ArrowDown') j = (i + 1) % n;
    else if (key === 'ArrowLeft' || key === 'ArrowUp') j = (i - 1 + n) % n;
    else if (key === 'Home') j = 0;
    else if (key === 'End') j = n - 1;
    if (j === i) return;
    rows.forEach(function (r, k) { r.setAttribute('tabindex', k === j ? '0' : '-1'); });
    try { rows[j].focus({ preventScroll: true }); } catch (e) { rows[j].focus(); }
  }

  /* ------------------------------------------------------------------------
     6 · La memoire du dernier format (VAGUE 7, point 3)
     ------------------------------------------------------------------------
     Les couleurs d'un meme modele sont des fiches distinctes. La cle de memoire
     doit donc etre la meme sur toutes : elle est DEDUITE de la famille, pas
     devinee. On prend le prefixe et le suffixe communs a tous les handles de la
     famille (la fiche courante et ses soeurs de couleur) :
       tapis-lavable-shaggy-aubergine-sahel
       tapis-lavable-shaggy-bleu-canard-sahel   ->  tapis-lavable-shaggy-*-sahel
     Le nom de la couleur est ce qui varie ; il est exactement ce qu'on retire.
     Sans soeur declaree, on retombe sur le dernier segment du handle, qui est
     le nom du modele (le meme que le titre met en italique). */
  function modelKey() {
    var cat = catalogue();
    if (!cat) return '';
    var hs = (cat.siblings || []).filter(Boolean);
    if (hs.length < 2) {
      var seg = String(cat.handle || '').split('-');
      return seg[seg.length - 1] || cat.handle || '';
    }
    /* On raisonne par SEGMENTS du handle, pas par caracteres. Sur les trois
       Valore (rouge-caramel, bleu-marine-caramel, caramel-marron), une
       comparaison caractere par caractere s'arrete au milieu d'un mot et donne
       « tapis-oriental-*e-caramel-valore » : une cle juste, mais illisible, et
       surtout fragile des qu'une couleur se termine par une autre lettre. Les
       segments donnent « tapis-oriental|valore », qui est le modele. */
    var parts = hs.map(function (h) { return String(h).split('-'); });
    var head = [], tail = [];
    var i, ok;
    for (i = 0; ; i++) {
      ok = parts.every(function (p) { return p.length > i && p[i] === parts[0][i]; });
      if (!ok) break;
      head.push(parts[0][i]);
    }
    for (i = 0; ; i++) {
      ok = parts.every(function (p) {
        return p.length > head.length + i && p[p.length - 1 - i] === parts[0][parts[0].length - 1 - i];
      });
      if (!ok) break;
      tail.unshift(parts[0][parts[0].length - 1 - i]);
    }
    return head.join('-') + '|' + tail.join('-');
  }

  function remember(size) {
    try {
      var k = modelKey();
      if (k && size) sessionStorage.setItem(STORE_PREFIX + k, size);
    } catch (e) {}
  }

  function restore() {
    var cat = catalogue();
    if (!cat || !cat.picker) return;
    /* Un lien profond `?variant=` est une intention explicite : on ne la
       contredit pas. On lit l'URL D'ARRIVEE, pas l'URL courante. */
    if (/[?&]variant=/.test(INITIAL_SEARCH)) return;
    var want;
    try { want = sessionStorage.getItem(STORE_PREFIX + modelKey()); } catch (e) { return; }
    if (!want) return;
    var cur = cat.byId[currentVariantId()];
    if (cur && cur.size === want) return;
    var target = null;
    cat.list.forEach(function (o) { if (!target && o.available && o.size === want) target = o; });
    if (!target || !target.row) return;
    target.row.click();
  }

  /* ------------------------------------------------------------------------
     7 · Les ecoutes
     ---------------------------------------------------------------------- */

  /* En CAPTURE, sur le document : ce listener s'execute AVANT celui que
     assets/casemira-dropdown-size-picker.js pose sur chaque ligne. C'est ce qui
     permet a la fois d'arreter le clic sur un format epuise et de repeindre
     avant que quoi que ce soit d'autre ne se passe. */
  document.addEventListener('click', function (e) {
    var t = e.target;
    if (!t || !t.closest) return;

    var goto = t.closest('[data-cm-goto]');
    if (goto) {
      e.preventDefault();
      var cat0 = catalogue();
      var dest = cat0 && cat0.byId[goto.getAttribute('data-cm-goto')];
      if (dest && dest.row) { clearOosLine(); dest.row.click(); }
      return;
    }
    var notify = t.closest('[data-cm-notify]');
    if (notify) {
      e.preventDefault();
      openNotify(notify, notify.getAttribute('data-cm-notify'));
      return;
    }

    var row = t.closest(ROW_SEL);
    if (!row || !row.closest(SECTION)) return;

    var cat = catalogue();
    if (!cat) return;
    var dim = row.classList.contains('dimension-btn');

    /* Le selecteur du thème n'a pas de reponse au format epuise : ses boutons
       portent `disabled`, donc aucun evenement. On ne fabrique pas ici une
       reponse qu'il n'a pas ; on se contente de ne rien peindre. */
    if (dim) {
      if (row.disabled || row.classList.contains('is-unavailable')) return;
    } else if (isOos(row)) {
      e.preventDefault();
      e.stopImmediatePropagation();
      refuse(row);
      return;
    }

    /* ★ C1 VAGUE 9, point 2 : la variante se resout par l'ENSEMBLE des options.
       Sur une fiche a une seule option, `resolveWith` retombe exactement sur la
       variante de la ligne : le chemin de la vague 7 n'est pas modifie. */
    var dest = cat.multi
      ? resolveWith(cat.sizeIndex, rowSizeValue(row))
      : cat.byId[String(row.getAttribute('data-variant-id'))];
    if (!dest) return;

    paint(dest.id);
    remember(dest.sizeValue);

    /* Qui met les selecteurs natifs en phase, et donc qui declenche la
       confirmation du serveur :
         - une seule option, notre tiroir  -> `selectRow()` de
           casemira-dropdown-size-picker.js, qui trouve la radio par le libelle.
           On ne double pas son `change`, sinon le thème part deux fois ;
         - le selecteur du thème            -> assets/dimension-picker.js, qui
           coche la taille ET la forme. Meme raison, on ne double pas ;
         - plusieurs options ET notre tiroir -> personne : le libelle de la
           variante ne correspond a aucune valeur de radio. C'est nous. */
    if (cat.multi && !dim) pushOptionInputs(dest);
  }, true);

  /* ★ C1 VAGUE 9, point 2 · TOUT CHANGEMENT D'OPTION, PAS SEULEMENT LA
     DIMENSION
     ------------------------------------------------------------------------
     Une fiche a deux options a un second groupe (la forme). Qu'il soit rendu
     visible par le thème ou pilote par un autre composant, il ecrit dans les
     memes radios, et son `change` remonte. On lit alors la combinaison
     complete et on repeint dans le meme tour d'evenement, sans attendre la
     Section Rendering API. `pushingOptions` evite de se repondre a soi-meme. */
  document.addEventListener('change', function (event) {
    if (pushingOptions) return;
    var t = event.target;
    if (!t || t.name === 'id' || !t.closest) return;
    if (!t.closest(SECTION + ' variant-selects')) return;
    if (t.type !== 'radio' && t.tagName !== 'SELECT') return;
    var dest = byOptions(optionsFromInputs());
    if (dest) paint(dest.id);
  }, true);

  document.addEventListener('keydown', function (e) {
    var t = e.target;
    var row = (t && t.closest) ? t.closest('.dw-picker__row') : null;
    if (!row || !row.closest(SECTION)) return;

    if (isFlat(row) && /^(ArrowLeft|ArrowRight|ArrowUp|ArrowDown|Home|End)$/.test(e.key)) {
      e.preventDefault();
      e.stopPropagation();
      moveFocus(row, e.key);
      return;
    }
    /* Dans le tiroir, le theme ecoute `keydown` sur le panneau et appelle
       `selectRow()` directement, sans passer par un clic : la garde du clic ne
       suffit donc pas, il faut arreter la touche ici. */
    if ((e.key === 'Enter' || e.key === ' ' || e.key === 'Spacebar') && isOos(row)) {
      e.preventDefault();
      e.stopImmediatePropagation();
      refuse(row);
    }
  }, true);

  /* On ne lit jamais event.detail.variant : voir l'en-tete. */
  document.addEventListener('variant:changed', function () {
    sync();
  });

  /* updateVariantInputs() de product-info.js dispatche un `change` bouillonnant
     sur input[name="id"] : c'est le signal le plus tot, et il porte deja la
     bonne valeur. Les configurateurs maison (couloir, sous-couche) ecrivent le
     meme input, ils passent donc par le meme chemin. */
  document.addEventListener(
    'change',
    function (event) {
      var t = event.target;
      if (t && t.name === 'id' && t.closest && t.closest(SECTION)) sync();
    },
    true
  );

  window.addEventListener('popstate', function () {
    sync();
  });

  /* ★ VAGUE 8, point 3 : la ligne du format epuise suit l'ouverture et la
     fermeture de la feuille basse. `casemira-dropdown-size-picker.js` bascule
     la classe `is-open` sur le composant : c'est le seul signal, on l'observe
     plutot que d'aller poser des gestionnaires sur le declencheur, le voile et
     la croix de fermeture (trois chemins, trois occasions d'en oublier un).
     L'observateur ne regarde qu'un attribut d'un seul element. */
  function watchDrawerState() {
    var picker = document.querySelector(SECTION + ' .dw-picker');
    if (!picker || !window.MutationObserver) return;
    new MutationObserver(function () {
      placeOosLine(picker);
      /* VAGUE 10 : la ligne « format proche » vient peut-etre d'entrer dans le
         panneau, donc le hors-liste a change de hauteur. Le palier se remesure
         apres elle, jamais avant. */
      applyPeek(picker);
    }).observe(picker, { attributes: true, attributeFilter: ['class'] });
    watchSheetScroll(picker);
    applyPeek(picker);
  }

  /* Une rotation d'ecran, ou une fenetre redimensionnee autour de 750 px,
     changent la reponse de isSheetOpen. */
  window.addEventListener('resize', function () {
    var picker = document.querySelector(SECTION + ' .dw-picker');
    if (!picker) return;
    placeOosLine(picker);
    applyPeek(picker);
  }, { passive: true });

  /* ★ C1 VAGUE 9, point 2 · LE RE-RENDU DU THEME NE REPREND PLUS LA MAIN
     ------------------------------------------------------------------------
     Au retour de la Section Rendering API, `handleUpdateProductInfo()` de
     assets/product-info.js ecrase le bloc de prix entier
     (`destination.innerHTML = source.innerHTML`, updateSourceFromDestination).
     Le HTML du serveur ne contient ni « Format : … » ni le libelle enrichi du
     bouton : ce sont des noeuds que la fiche ajoute apres coup. Tant que le
     serveur confirme la MEME variante que celle deja peinte, cet ecrasement
     n'a donc rien a apporter et tout a defaire.

     La garde repose ce qui manque DANS LE MEME TOUR que le remplacement, avant
     que le navigateur ne peigne : un MutationObserver est appele en microtache,
     donc toujours avant le rendu suivant. Elle ne se declenche que si le DOM
     s'ecarte de ce qui a ete peint (`differs`), ce qui la rend non recursive :
     sa propre ecriture ne peut pas la rappeler indefiniment. Et elle se tait
     des que le serveur repond une AUTRE variante que la notre : c'est lui qui
     a raison, c'est lui qui part au panier.

     Mesure du 22/08, avant : sur les fiches a deux options, le prix, le format,
     le bouton et l'identifiant restaient ceux de l'ancien format pendant
     254,6 ms, et la mensualite Klarna pendant 312 ms. */
  function differs(v) {
    var host = scope();
    if (!host) return false;
    var fmt = host.querySelector('.cm-price-format');
    var size = v.size;
    if (size && !/cm\s*$/i.test(size)) size += ' cm';
    if (size && (!fmt || fmt.textContent.replace(/\s+/g, ' ').trim() !== 'Format : ' + size)) return true;
    var item = host.querySelector('.product__block--price [id^="price-"] .f-price-item--regular');
    if (item && v.priceMoney && item.textContent.replace(/\s+/g, ' ').trim() !== v.priceMoney) return true;
    return false;
  }

  function guardVisibleNodes() {
    var host = scope();
    if (!host || host.__cmPaintGuard || !window.MutationObserver) return;
    var price = host.querySelector('.product__block--price');
    if (!price) return;
    host.__cmPaintGuard = 1;
    new MutationObserver(function () {
      if (painting || !LAST_PAINTED) return;
      /* Le serveur a tranche autrement : on s'efface. */
      if (currentVariantId() !== LAST_PAINTED) return;
      var cat = catalogue();
      var v = cat && cat.byId[LAST_PAINTED];
      if (!v || !differs(v)) return;
      paint(LAST_PAINTED);
    }).observe(price, { childList: true, subtree: true, characterData: true });
  }

  function boot() {
    mediaGuard();
    guardVisibleNodes();
    watchDrawerState();
    if (INITIAL_ID === null) INITIAL_ID = currentVariantId();
    sync();
    restore();
    /* casemira-scarcity-stock.js pose ses libelles en fin de chargement (et les
       remesure en requestAnimationFrame) : une seconde passe suffit a rendre la
       ligne de rarete des le premier ecran. */
    requestAnimationFrame(function () {
      mediaGuard();
      guardVisibleNodes();
      sync();
    });
    setTimeout(sync, 300);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  /* Une seule chose est exposee, et elle sert aux mesures de la vague : de quoi
     lire le catalogue et repeindre depuis la console. Rien du comportement n'en
     depend. */
  window.CM_SIZE_PICKER = {
    catalogue: catalogue,
    paint: paint,
    modelKey: modelKey
  };
})();
